export const mapStringListToStringWithSemicolon: (list: string[]) => string = (list: string[]) => list?.join('; ');
